<template>
  <div class="header">
    <div class="globalStyle">
      <div class="companyname">
        <img src="/static/imgs/icon_logo.png" alt="" >
        <div class="c_Title">
          <p>{{$t("footer.CompanyName")}}</p>
          <p>www.yjenjoy.cn</p>
        </div>
      </div>
      <ul>
        <router-link tag="li" to="/main/home" active-class="activeClass">{{$t("header.l1")}}</router-link>
        <router-link tag="li" to="/main/ProductsUsing" active-class="activeClass">{{$t("header.l2")}}</router-link>
        <router-link tag="li" to="/main/CooperationCase" active-class="activeClass">{{$t("header.l3")}}</router-link>
        <router-link tag="li" to="/main/CompanyIntr" active-class="activeClass">{{$t("header.l4")}}</router-link>
        <router-link tag="li" to="/main/ContactUs" active-class="activeClass">{{$t("header.l5")}}</router-link>
      </ul>
      <div class="changelanguage">
        <p :class="isChange=='zh' ? '' : 'colorC'" @click="change('zh')">中文</p><i>|</i><p :class="isChange=='en' ? '' : 'colorC'" @click="change('en')">English</p>
      </div>
    </div>
  </div>
</template>
<script>
import pubsub from 'pubsub-js'
import { setup } from "../../locales/index.js";
export default {
  data () {
    return {
      isChange: localStorage.getItem('localeLanguage') ? localStorage.getItem('localeLanguage') : 'zh'
    }
  },
  mounted (){
    setup(this.isChange);
  },
  methods:{
    change(language){
      this.isChange = language
      setup(language)
      pubsub.publish('lang', language)
    },
  }
}
</script>
<style scoped>
.header{
  height:6.67rem;
  background:rgba(32,32,32,1);
  width: 100%;
  align-items: center;
  padding: auto 3rem;
}
.globalStyle{
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  font-size: 0.8rem;
}
.companyname{
  width: 22rem;
  height:4.5rem;
  margin-right: 1.5rem;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  font-family:STSongti-SC-Regular;
}
.companyname img{
  width:5rem;
  margin-right: 0.8rem;
}
.c_Title{
  font-size:0.93rem;
  color: #fff;
}
.c_Title p:nth-child(1){
  width: 14rem;
  margin-bottom: 0.3rem;
}
ul{
  width:50rem;
  display: flex;
  justify-content: space-around;
  align-items: center;
}
li{
  /* width:7.5rem; */
  height:6.67rem;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.activeClass{
  background:rgba(66,153,35,1);
}
.changelanguage{
  margin-left: 1rem;
  display: flex;
  justify-content: center;
  align-items: center;
  white-space: nowrap;
}
.changelanguage i{
  margin:0 0.5rem;
}
.changelanguage p{
  cursor: pointer;
}
.colorC{
  color: #AAAAAA;
}
</style>


// WEBPACK FOOTER //
// src/components/common/headerPage.vue